import { SPATEM } from '_lib/api';
import { spatemsSelector } from '_store/spatem/selectors';
import React, { FC, useMemo } from 'react';
import { useSelector } from 'react-redux';

import CardSpatemListItem from './Card';

export interface SpatemLayoutSingleProps {
  id: string;
}

// detail card of selected SPATEM
const SpatemLayoutSingle: FC<SpatemLayoutSingleProps> = ({ id }) => {
  const spatems = useSelector(spatemsSelector);
  // Use useMemo to ensure we get the latest spatem when the array updates
  const spatem = useMemo(() => spatems.find((s) => s.id === id), [spatems, id]);

  if (!spatem) {
    return <>Could not find SPATEM</>;
  }

  return (
    <CardSpatemListItem
      spatem={spatem}
      asCard={false}
      text={spatem.name || spatem.identifier || spatem.id || ''}
    />
  );
};

export default React.memo(SpatemLayoutSingle);

